import { useEffect, useState, useSyncExternalStore } from 'react';
import { GameController } from '../core/GameController';
import { GameCanvas } from './GameCanvas';
import { MainMenu, SplashScreen } from './screens/MenuScreens';
import { CarSelectScreen, TrackSelectScreen } from './screens/SelectionScreens';
import { SettingsScreen } from './screens/SettingsScreen';
import { RaceOverlay } from './screens/RaceOverlay';
import { ResultsScreen } from './screens/ResultsScreen';

export function App() {
  const [controller] = useState(() => new GameController());
  const snapshot = useSyncExternalStore(controller.subscribe, controller.getSnapshot, controller.getSnapshot);

  useEffect(() => {
    controller.start();
    return () => controller.dispose();
  }, [controller]);

  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      const candidate = document.querySelector<HTMLElement>('.screen-layer button[autofocus], .screen-layer button:not([disabled])');
      candidate?.focus({ preventScroll: true });
    });
    return () => cancelAnimationFrame(frame);
  }, [snapshot.screen, snapshot.paused, snapshot.transitionKey]);

  return (
    <main className={`game-shell screen-${snapshot.screen} ${snapshot.paused ? 'is-paused' : ''}`}>
      <GameCanvas controller={controller} />
      <div className="game-grade" aria-hidden="true" />
      {snapshot.screen === 'splash' && <SplashScreen controller={controller} />}
      {snapshot.screen === 'menu' && <MainMenu controller={controller} snapshot={snapshot} />}
      {snapshot.screen === 'track-select' && <TrackSelectScreen controller={controller} snapshot={snapshot} />}
      {snapshot.screen === 'car-select' && <CarSelectScreen controller={controller} snapshot={snapshot} />}
      {snapshot.screen === 'settings' && <SettingsScreen controller={controller} snapshot={snapshot} />}
      {snapshot.screen === 'race' && <RaceOverlay controller={controller} snapshot={snapshot} />}
      {snapshot.screen === 'results' && <ResultsScreen controller={controller} snapshot={snapshot} />}
      {snapshot.toast && <div className="global-toast" role="status">{snapshot.toast}</div>}
      <div className="sr-only" aria-live="polite">
        Current screen: {snapshot.screen.replace('-', ' ')}
      </div>
    </main>
  );
}
